import React, {useState} from 'react';
import classNames from 'classnames';
import {AssetType} from '@taopix/taopix-core';
import {AssetMetaInterface} from '@taopix/taopix-core/dist/types/types';
import {Checkbox, Shimmer, ThemeName, getTheme} from '@taopix/taopix-design-system';
import useImageLoader from '../../Hooks/Assets/useImageLoader';
import {useInView} from 'react-intersection-observer';
import {useTranslation} from 'react-i18next';

export type MaskThumbnailProps = {
  columns: number;
  columnGap?: number;
  mask: AssetMetaInterface;
  onClick: (maskAsset: AssetMetaInterface) => void;
  checked: boolean;
};

const MaskThumbnail = ({mask, columns, columnGap = 5, onClick, checked}: MaskThumbnailProps) => {
  const {ref, inView} = useInView({
    threshold: 0.2,
  });
  const src = useImageLoader(mask, AssetType.Mask, inView);
  const [loaded, setLoaded] = useState(false);
  const {t} = useTranslation(['toolpalette']);

  const thumbnailContainerClassess = classNames([
    'relative',
    'before:block',
    'before:pt-[100%]',
    'cursor-pointer',
    'mt-[var(--gap)]',
    'ml-[var(--gap)]',
    // 'overflow-hidden',
    'w-[calc((100%_-_(var(--gap)_*_var(--columns)))_/_var(--columns))]',
    'rounded-[min(theme(borderRadius.themeCornerSize),5px)]',
    getTheme(ThemeName.Section, true, !checked, false),
    'rounded-[min(theme(borderRadius.themeCornerSize),5px)]',
  ]);

  const thumbnailClassess = ['object-contain'];

  return (
    <li key={`li-${mask.assetRef}-${checked}`} className={thumbnailContainerClassess} ref={ref}>
      {!loaded && <Shimmer className={'absolute top-0'} />}

      {inView && (
        <div className={'absolute top-0 left-0 cursor-pointer w-full h-full'}>
          <Checkbox
            label={t('*:str_LabelMask')}
            id={`mask-checkbox-${mask.id}`}
            defaultChecked={checked}
            appearance={'border'}
            hideLabel
            className={'h-full w-full'}
            disabled={!loaded}
            onChange={() => {
              if (loaded) onClick(mask);
            }}
          >
            {src !== '' ? (
              <img
                className={thumbnailClassess.join(' ')}
                src={src}
                draggable={false}
                alt={'mask'}
                onLoad={() => setLoaded(true)}
                style={!loaded ? {display: 'none'} : {}}
              />
            ) : (
              <></>
            )}
          </Checkbox>
        </div>
      )}
    </li>
  );
};
export default MaskThumbnail;
